import { Component, Input, OnInit } from '@angular/core';
import { Cell } from '../../cell';
import { LayoutService } from '../../layout.service';
import * as g from 'src/app/globals';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-cell-select',
  templateUrl: './cell-select.component.html',
  styleUrls: ['./cell-select.component.less'],
})
export class CellSelectComponent extends Cell {
  constructor(
    public layoutService: LayoutService,
    public drawerService: NzDrawerService
  ) {
    super(layoutService, drawerService);
  }
}
